import { Spin } from 'antd';

const Loading = () => (
  <div className="container-spinner">
    <Spin tip="Loading..." size="large" />
  </div>
);

export default Loading;
